module.exports = __webpack_public_path__ + "img/exam_jan_2025_te6z71b5.0b9e0efc.jpg";